import { Skeleton, Typography } from "@mui/material"
import { groupBy } from "@shared/lib/utils";
import MuiInput from "@shared/ui/mui-input/MuiInput";
import { UseFormReturn } from "react-hook-form";
import { StyledAddOutcome } from "./AddOutcome.styled";
import { AccountAdd } from "../../../../../models/account";
import { useGetAccountStructureQuery } from "@features/structures/api/accountsStructure.api";
import { useTheme } from "@emotion/react";


interface AddOutcomeProps {
  useForm: UseFormReturn<AccountAdd>
}

function AddOutcome({ useForm }: AddOutcomeProps) {

  const theme = useTheme();

  const { 
    data: outcomeStructure,
    isFetching,
  } = useGetAccountStructureQuery("הוצאה");

  const structureSortedByTitle = groupBy(outcomeStructure, "account_title")
  const customFieldsExist = structureSortedByTitle?.["מותאם אישית"]?.find(structure=> !!structure.show_form === true);

  return (
    <StyledAddOutcome>
      {isFetching && (<Skeleton variant="rectangular" height={500} animation="wave" sx={{ bgcolor: theme.colors.section_color }} />)}
      {!isFetching && outcomeStructure &&
        <>
          <div>
            <Typography variant="body1">פרטים</Typography>
            <div className="fields">
              {structureSortedByTitle?.["פרטים"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            {customFieldsExist && (<Typography variant="body1">שדות מותאמים אישית:</Typography>)}
            <div className="fields">
              { structureSortedByTitle?.["מותאם אישית"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

        </>}

    </StyledAddOutcome>
  )
}

export default AddOutcome